export default "__VITE_ASSET__Bmcy0GGm__"